export const deliveryTypes = [
    { value: '1hr', label: '1 Hour' },
    { value: '24hr', label: '24 Hour' },
  ];
  